import React, { useEffect, useRef, useState } from "react";

const NaverMapRoute = () => {
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [start, setStart] = useState("");
  const [waypoints, setWaypoints] = useState("");
  const [goal, setGoal] = useState("");
  const [routeInfo, setRouteInfo] = useState(null);

  useEffect(() => {
    const { naver } = window;
    if (!naver) return;

    const mapOptions = {
      center: new naver.maps.LatLng(37.5665, 126.978),
      zoom: 13,
    };

    const mapInstance = new naver.maps.Map(mapRef.current, mapOptions);
    setMap(mapInstance);
  }, []);

  // 주소를 좌표로 변환하는 함수
  const geocode = async (address) => {
    const res = await fetch(
      `/naver-geocode?query=${encodeURIComponent(address)}`
    );
    const data = await res.json();
    const { x, y } = data.addresses[0];
    return { lat: parseFloat(y), lng: parseFloat(x) };
  };

  // 길찾기 요청
  const handleRoute = async () => {
    if (!start || !goal) {
      alert("출발지와 목적지를 입력해주세요.");
      return;
    }

    const startCoord = await geocode(start);
    const goalCoord = await geocode(goal);

    const waypointList = waypoints
      ? await Promise.all(
          waypoints.split(",").map(async (wp) => await geocode(wp.trim()))
        )
      : [];

    const res = await fetch("http://localhost:5000/naver-directions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        start: startCoord,
        waypoints: waypointList,
        goal: goalCoord,
      }),
    });

    const data = await res.json();
    setRouteInfo(data);

    if (data?.route?.trafast?.[0]?.path && map) {
      const path = data.route.trafast[0].path.map(
        ([lng, lat]) => new window.naver.maps.LatLng(lat, lng)
      );

      new window.naver.maps.Polyline({
        path,
        map,
        strokeColor: "#0078FF",
        strokeWeight: 4,
      });

      // 지도 범위 자동 조정
      const bounds = new window.naver.maps.LatLngBounds();
      path.forEach((p) => bounds.extend(p));
      map.fitBounds(bounds);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: "12px" }}>
        <input
          type="text"
          placeholder="출발지 입력"
          value={start}
          onChange={(e) => setStart(e.target.value)}
        />
        <input
          type="text"
          placeholder="경유지 (쉼표로 구분)"
          value={waypoints}
          onChange={(e) => setWaypoints(e.target.value)}
        />
        <input
          type="text"
          placeholder="도착지 입력"
          value={goal}
          onChange={(e) => setGoal(e.target.value)}
        />
        <button onClick={handleRoute}>길찾기</button>
      </div>

      <div
        ref={mapRef}
        style={{ width: "100%", height: "500px", borderRadius: "8px" }}
      ></div>

      {routeInfo?.route?.trafast && (
        <div style={{ marginTop: "10px" }}>
          <h3>🚗 경로 정보</h3>
          <p>거리: {routeInfo.route.trafast[0].summary.distance / 1000} km</p>
          <p>예상 소요 시간: {Math.round(routeInfo.route.trafast[0].summary.duration / 60000)} 분</p>
          <p>유류비: {routeInfo.route.trafast[0].summary.fuelPrice} 원</p>
          <p>통행요금: {routeInfo.route.trafast[0].summary.tollFare} 원</p>
        </div>
      )}
    </div>
  );
};

export default NaverMapRoute;
